/**
 * O lado com EFEITO do `limites-do-quadro-em-ios.ts`: importar este arquivo arma os
 * limites do quadro branco, uma vez, no carregamento do módulo.
 *
 * Está separado do módulo de decisão pelo mesmo motivo de todo `decidir-*.ts` deste
 * repositório: a decisão se testa sem navegador e sem blocksuite; só o armador precisa dos
 * dois. Juntá-los faria o teste arrastar o editor inteiro para dentro do `node --test`.
 *
 * ## Por que no carregamento do módulo, e não num `useEffect`
 *
 * O `viewport.ts` do upstream é explícito: os limites precisam valer **antes de qualquer
 * editor montar**, porque cada `Viewport` os lê no construtor.
 *
 * > *"Setting them at construction (rather than mutating a live Viewport afterward) avoids
 * > both the race condition and the wrong-instance problem that previously left the preview
 * > viewport on desktop defaults."*
 *
 * Por isso o import mora no topo do `setup.ts` de cada entrypoint, que o `index.tsx`
 * importa antes de montar a aplicação.
 *
 * ## Por que isto é inerte no desktop
 *
 * `decidir()` devolve `nao-e-ios` quando `IS_IOS` e `IS_IPAD` são falsos, e nesse caminho
 * **nenhuma chave é escrita**. Num desktop o arquivo carrega, decide e sai — o
 * comportamento é byte a byte o de antes.
 */

import { IS_IOS, IS_IPAD } from '@blocksuite/affine/global/env';
import { viewportRuntimeConfig } from '@blocksuite/affine/std/gfx';

import {
  aplicarLimitesDoQuadro,
  type LimitesDoQuadro,
} from './limites-do-quadro-em-ios';

export const motivoDosLimitesDoQuadro = aplicarLimitesDoQuadro(
  viewportRuntimeConfig as unknown as LimitesDoQuadro,
  { ehIOS: IS_IOS, ehIPad: IS_IPAD }
);
